import axiosClient from './axiosClient';

export const contactService = {
  /**
   * Send a Contact Us message: POST /api/contact (multipart/form-data).
   * Resolves only on a 2xx answer; axiosClient rejects everything else with
   * `error.status` set, which the form turns into a "not sent" message.
   *
   * @param {FormData} body - buildContactFormData output
   */
  sendMessage: async (body) => {
    const response = await axiosClient.post('/api/contact', body, {
      // The client defaults to JSON, and axios turns a FormData body into JSON
      // under that header -- dropping the attachment. Declaring multipart keeps
      // the FormData intact; the browser then supplies the boundary itself.
      headers: { 'Content-Type': 'multipart/form-data' },
      // A 10 MB attachment on a slow connection can outlast the 30 s default
      timeout: 60000,
    });
    return response.data;
  },
};

export default contactService;
